import { QueryClient } from '@tanstack/react-query';
import { ApiError } from './api/core.js';

/**
 * One client for the whole app. Retries are conservative: a 4xx from the API is
 * a verdict, not a transient failure, so only network errors are retried.
 */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      gcTime: 5 * 60_000,
      refetchOnWindowFocus: false,
      retry: (failureCount, error) => {
        if (error instanceof ApiError && error.status >= 400 && error.status < 500) return false;
        return failureCount < 2;
      },
    },
    mutations: {
      retry: false,
    },
  },
});
